import { SearchContentModel } from '../../../Partials/Shared/search-content-by-type/models/search-content.model';
import ListItem from '../../../../models/list/list-item/ListItem';
import { ContentTypes, FuContentTypes } from '../../../../constants/content-types';
import ModelMapper from '../../../../models/ModelMapper';
import ListItemMeta from '../../../../models/list/list-item/list-item-meta/ListItemMeta';
import List from '../../../../models/list/List';
import { responseToLiveBlogModel } from '../../../Pages/Live Blog/models/live-blog.mapper';
import { isFuOption } from '../../../Partials/Shared/search-content-by-type/helpers/search-content-by-type-container.helper';

export const cssIconByContentType = {
	article: 'fa-file-text',
	video: 'fa-video-camera',
	gallery: 'fa-camera',
	tag: 'fa-tags',
	sports_connections: `fa-medal`,
	live_blog: 'fa-solid fa-newspaper',
};

export const svgFuIconByContentType = {
	match_quiz:
		'data:image/svg+xml;base64,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',
	classic_quiz:
		'data:image/svg+xml;base64,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',
	poll:
		'data:image/svg+xml;base64,PG5zMDpzdmcgeG1sbnM6bnMwPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiPgo8bnMwOmcgaWQ9Imhvd190b192b3RlIj4KPG5zMDptYXNrIGlkPSJtYXNrMF8xMDMzXzc0MyIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ij4KPG5zMDpyZWN0IGlkPSJCb3VuZGluZyBib3giIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iI0Q5RDlEOSIgLz4KPC9uczA6bWFzaz4KPG5zMDpnIG1hc2s9InVybCgjbWFzazBfMTAzM183NDMpIj4KPG5zMDpwYXRoIGlkPSJob3dfdG9fdm90ZV8yIiBkPSJNMy4zMzMzMyAxNC42NjY2QzIuOTY2NjcgMTQuNjY2NiAyLjY1Mjc4IDE0LjUzNjEgMi4zOTE2NyAxNC4yNzVDMi4xMzA1NiAxNC4wMTM5IDIgMTMuNyAyIDEzLjMzMzNWMTAuM0wzLjgzMzMzIDguMjE2NjVMNC43ODMzMyA5LjE2NjY1TDMuNDUgMTAuNjY2NkgxMi41NUwxMS4yNSA5LjE5OTk4TDEyLjIgOC4yNDk5OEwxNCAxMC4zVjEzLjMzMzNDMTQgMTMuNyAxMy44Njk0IDE0LjAxMzkgMTMuNjA4MyAxNC4yNzVDMTMuMzQ3MiAxNC41MzYxIDEzLjAzMzMgMTQuNjY2NiAxMi42NjY3IDE0LjY2NjZIMy4zMzMzM1pNMy4zMzMzMyAxMy4zMzMzSDEyLjY2NjdWMTJIMy4zMzMzM1YxMy4zMzMzWk03LjA4MzMzIDkuNTgzMzFMNC43MzMzMyA3LjIzMzMxQzQuNDc3NzggNi45Nzc3NiA0LjM1Mjc4IDYuNjYzODcgNC4zNTgzMyA2LjI5MTY1QzQuMzYzODkgNS45MTk0MiA0LjQ5NDQ0IDUuNjA1NTMgNC43NSA1LjM0OTk4TDguMDE2NjcgMi4wODMzMUM4LjI3MjIyIDEuODI3NzYgOC41ODg4OSAxLjY5NDQyIDguOTY2NjcgMS42ODMzMUM5LjM0NDQ0IDEuNjcyMiA5LjY2MTExIDEuNzk0NDIgOS45MTY2NyAyLjA0OTk4TDEyLjI2NjcgNC4zOTk5OEMxMi41MjIyIDQuNjU1NTMgMTIuNjU1NiA0Ljk2NjY1IDEyLjY2NjcgNS4zMzMzMUMxMi42Nzc4IDUuNjk5OTggMTIuNTU1NiA2LjAxMTA5IDEyLjMgNi4yNjY2NEw4Ljk2NjY3IDkuNTk5OThDOC43MTExMSA5Ljg1NTUzIDguMzk3MjIgOS45ODA1MyA4LjAyNSA5Ljk3NDk4QzcuNjUyNzggOS45Njk0MiA3LjMzODg5IDkuODM4ODcgNy4wODMzMyA5LjU4MzMxWk0xMS4zMzMzIDUuMzQ5OThMOC45ODMzMyAyLjk5OTk4TDUuNjgzMzMgNi4yOTk5OEw4LjAzMzMzIDguNjQ5OThMMTEuMzMzMyA1LjM0OTk4WiIgZmlsbD0iIzFDMUIxRiIgLz4KPC9uczA6Zz4KPC9uczA6Zz4KPC9uczA6c3ZnPg==\n',
};

export const searchContentModelToListItem = (model: SearchContentModel): ListItem => {
	if (model.type.toLowerCase() === ContentTypes.ARTICLE) {
		return ListItem.builder()
			.withData(ModelMapper.remapArticleFromResponse(model.data))
			.withType(model.type)
			.withMeta({} as ListItemMeta)
			.build();
	}

	if (model.type.toLowerCase() === ContentTypes.VIDEO) {
		return ListItem.builder()
			.withData(ModelMapper.remapVideoFromResponse(model.data))
			.withType(model.type)
			.withMeta({} as ListItemMeta)
			.build();
	}

	if (model.type.toLowerCase() === ContentTypes.GALLERY) {
		return ListItem.builder()
			.withData(ModelMapper.remapGalleryFromResponse(model.data))
			.withType(model.type)
			.withMeta({} as ListItemMeta)
			.build();
	}

	if (model.type.toLowerCase() === ContentTypes.TAG) {
		return ListItem.builder()
			.withData(ModelMapper.remapTagFromResponse(model.data))
			.withType(model.type)
			.withMeta({} as ListItemMeta)
			.build();
	}

	if (model.type.toLowerCase() === ContentTypes.LIVE_BLOG) {
		return ListItem.builder()
			.withData(responseToLiveBlogModel(model.data))
			.withType(model.type)
			.withMeta({} as ListItemMeta)
			.build();
	}

	if (
		model.type.toLowerCase() === ContentTypes.COACH ||
		model.type.toLowerCase() === ContentTypes.TEAM ||
		model.type.toLowerCase() === ContentTypes.PLAYER ||
		model.type.toLowerCase() === ContentTypes.TOURNAMENT ||
		model.type.toLowerCase() === ContentTypes.VENUE ||
		model.type.toLowerCase() === ContentTypes.COMPETITION ||
		model.type.toLowerCase() === ContentTypes.PRESIDENT ||
		model.type.toLowerCase() === ContentTypes.ARENA
	) {
		return ListItem.builder()
			.withData({
				id: model.data.id.toString(),
				title: model.data.name,
				type: model.data.entity_type,
				image: extractCorrectImageUrl(model),
				entity_type: model.data.entity_type,
			})
			.withType('RELATEDCONTENT')
			.withMeta({} as ListItemMeta)
			.build();
	}

	if (isFuOption(model.type)) {
		switch (model.type) {
			case FuContentTypes.POLL:
				return ListItem.builder()
					.withData(responseToFuListOptionItemModel(model))
					.withType('FANS_UNITED')
					.withMeta({} as ListItemMeta)
					.build();
			case FuContentTypes.CLASSIC_QUIZ:
				return ListItem.builder()
					.withData(responseToFuListOptionItemModel(model))
					.withType('FANS_UNITED')
					.withMeta({} as ListItemMeta)
					.build();
			default:
				return ListItem.builder()
					.withData(responseToFuListOptionItemModel(model))
					.withType('FANS_UNITED')
					.withMeta({} as ListItemMeta)
					.build();
		}
	}

	return {} as ListItem;
};

export const responseToFuListOptionItemModel = (model: SearchContentModel) => {
	if (model.data) {
		return {
			id: model.data.id,
			title: model.data.title,
			description: model.data.description ? model.data.description : null,
			type: model.type.toUpperCase(),
			images: {
				main: model.data.images ? model.data.images.main : null,
				cover: model.data.images ? model.data.images.cover : null,
				mobile: model.data.images ? model.data.images.mobile : null,
			},
		};
	}

	return {};
};

export const extractCorrectImageUrl = (model: SearchContentModel) => {
	if (model.type.toLowerCase() === ContentTypes.TEAM || model.type.toLowerCase() === ContentTypes.TOURNAMENT) {
		return model.data.url_logo ? model.data.url_logo : model.data.display_asset && model.data.display_asset.url;
	} else if (model.type.toLowerCase() === ContentTypes.PLAYER || model.type.toLowerCase() === ContentTypes.COACH) {
		return model.data.url_thumb ? model.data.url_thumb : model.data.display_asset && model.data.display_asset.url;
	} else if (model.type.toLowerCase() === ContentTypes.VENUE) {
		return model.data.url_image;
	} else if (model.type.toLowerCase() === ContentTypes.ARENA) {
		return model.data.display_asset && model.data.display_asset.url;
	} else if (model.type.toLowerCase() === ContentTypes.COMPETITION) {
		return model.data.display_asset && model.data.display_asset.url;
	}
};

export const isNumberofItemsValid = (list: List): boolean => {
	if (list.configuration === undefined || list.configuration === null) {
		return true;
	}

	const minItems = list.configuration.minItems ? parseInt(list.configuration.minItems) : list.configuration.minItems;
	const maxItems = list.configuration.maxItems ? parseInt(list.configuration.maxItems) : list.configuration.maxItems;
	const numberOfItems = list.items.length;

	if ((minItems === undefined || minItems === null) && (maxItems === undefined || maxItems === null)) {
		return true;
	} else if ((minItems === undefined || minItems === null) && maxItems && numberOfItems <= maxItems) {
		return true;
	} else if ((maxItems === undefined || maxItems === null) && minItems && numberOfItems >= minItems) {
		return true;
	}

	return numberOfItems <= maxItems && numberOfItems >= minItems;
};

export const validateLockPositions = (list: List) => {
	if (list && list.items && list.lockedPositions) {
		const lockedItems = list.items.filter((item: ListItem, index: number) => list.lockedPositions.includes(index));
		return lockedItems.length < list.lockedPositions.length;
	}
	return false;
};

export const lockPositionsAlert = (list: List) => {
	if (list && list.lockedPositions) {
		return list.lockedPositions.map((position: number) => position + 1).join(', ');
	}
	return '';
};

export const addToListIfNotExists = (itemToAdd: ListItem, items: ListItem[], addItemToTop?: boolean): ListItem[] => {
	const selectedItems = items ? items : [];
	const index = selectedItems.findIndex((item: ListItem) => {
		return (
			item.data &&
			item.data.id === itemToAdd.data &&
			itemToAdd.data.id &&
			item.data.entity_type === itemToAdd.data.entity_type &&
			item.data.name === itemToAdd.data.name
		);
	});
	if (index === -1) {
		addItemToTop ? selectedItems.unshift(itemToAdd) : selectedItems.push(itemToAdd);
	}

	return selectedItems;
};

export const extractSearchOptionId = (itemOption: SearchContentModel) => {
	return itemOption && itemOption.id;
};

export const returnCorrectUrlPathToContent = (option: ListItem) => {
	return option.type && option.type.toLowerCase() === `${ContentTypes.LIVE_BLOG}`
		? `/smp/live-blogs/editorial-admin/${option.data && option.data.id}`
		: `/smp/${option.type && option.type.toLowerCase()}s/edit/${option.data && option.data.id}`;
};
